/**
 * Redirect
 *
 * @module redirect
 */
const component = {

  /**
   * Init component
   *
   * @returns {undefined}
   */
  init: async () => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("noredirect")) {
      localStorage.setItem("noredirect", 'true');
    }

    if (!localStorage.getItem("noredirect")) {
      try {
        const response = await fetch('/browsing_context_suggestions.json');
        const data = await response.json();

        if (data) {
          const country = data.detected_values.country.handle;

          if (country === 'GB') {
            window.location.href = 'https://dressthepopulation.co.uk';
          }
        }
      } catch (error) {
        console.error('Error fetching country:', error);
      }
    }
  },
};

export default component;
